import React from 'react'
;
import { Link } from 'react-router-dom';

const HeroSlider = () => {

  

  return (
    <div className="slider1-area overlay-default">
      <div className="bend niceties preview-1">
        <div id="ensign-nivoslider-3" className="slides">
          <img src="/images/slider1.jpg" style={{ display: 'inline', width: 375, visibility: 'hidden' }} alt="slider" title="#slider-direction-1" />
          <img src="/images/slider2.jpg" alt="slider" title="#slider-direction-2" />
          <img src="/images/sider-3.jpg" alt="slider" title="#slider-direction-3" />
          <img src="/images/sider-2.jpg" alt="slider" title="#slider-direction-4" />
          <img src="/images/slider5.jpg  " alt="slider" title="#slider-direction-5" />
        </div>
        <div id="slider-direction-1" className="t-cn slider-direction">
          <div className="slider-content s-tb slide-1">
            <div className="title-container s-tb-c">

            </div>
          </div>
        </div>
        <div id="slider-direction-2" className="t-cn slider-direction">
          <div className="slider-content s-tb slide-1">
            <div className="title-container s-tb-c">
              <div className="title1">Way To Digital World</div>
              <p>Computer Education, Technical Education, Fashion Design &amp; Parlor &amp; Hair Style
                <br />Remote Sensing and GIS Training Programs<br />
                Digital and Paper Less Work with ITT Council<br />
                100% Job Oriented Course and Diploma<br />
              </p>
              <div className="slider-btn-area">
                <Link to='/allcourses' className="default-big-btn">View a Course</Link>
              </div>
            </div>
          </div>
        </div>
        <div id="slider-direction-3" className="t-cn slider-direction">
          <div className="slider-content s-tb slide-2">
            <div className="title-container s-tb-c">
              <div className="title1">Remote Sensing And GIS Training Programs</div>
              <p>Visit Your Nearest ITT Council Authorise Traning Center
              </p>
              <div className="slider-btn-area">
                <Link to='/remotesensing' className="default-big-btn">View GIS Course</Link>
              </div>
            </div>
          </div>
        </div>
        <div id="slider-direction-4" className="t-cn slider-direction">
          <div className="slider-content s-tb slide-2">
            <div className="title-container s-tb-c">
              <div className="title1">Best Education In Software Development</div>
              <p>Visit Your Nearest ITT Council Authorise Traning Center
              </p>
              <div className="slider-btn-area">
                <Link to='/allcourses' className="default-big-btn">View a Course</Link>
              </div>
            </div>
          </div>
        </div>
        <div id="slider-direction-5" className="t-cn slider-direction">
          <div className="slider-content s-tb slide-3">
            <div className="title-container s-tb-c">
              <div className="title1">Fashion Design, Parlour &amp; Hairstyle</div>
              <p>ITT-Council Present Fashion Design, Parlour &amp; Hairstyle, Courses and Diploma
                Registerd Your Institute with us
              </p>
              <div className="slider-btn-area">
                <Link to='/fashion' className="default-big-btn">View a Course</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



  )
}

export { HeroSlider };